// components/ServiceCard.js
import React, { useState } from "react";
import DemoForm from "./DemoForm";

function ServiceCard({
  title,
  subtitle,
  description,
  tags,
  imageSrc,
  moduleName,
}) {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <article className="mod-card" role="listitem">
        <div className="mod-head">
          <div className="mod-badge" aria-hidden="true">
            <img
              src={require("../" + imageSrc)}
              alt=""
              width="28"
              height="28"
              style={{
                width: "31px",
                height: "auto",
                filter: "drop-shadow(0 2px 6px rgba(0,0,0,.35))",
              }}
            />
          </div>
          <div>
            <h3 className="mod-title"> {title} </h3>
            <p className="mod-sub"> {subtitle} </p>
          </div>
        </div>
        <p className="mod-copy">
          <br />
          {description}
        </p>
        <div className="mod-tags">
          {tags.map((tag, index) => (
            <span key={index} className="mod-tag">
              {tag}
            </span>
          ))}
        </div>
        <div className="mod-cta">
          <button
            className="btn primary"
            onClick={() => setShowForm(true)}
            data-module={moduleName}
          >
            Richiedi demo
          </button>
        </div>
      </article>

      {showForm && (
        <DemoForm onClose={() => setShowForm(false)} moduleName={moduleName} />
      )}
    </>
  );
}

export default ServiceCard;
